import { Injectable } from '@angular/core';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Injectable()
export class ListYourBoatSessionService {
  public vessel: Vessel;
}
